import { Directive, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, FormGroup, Validators } from '@angular/forms';

function noWhitespaceValidator(control: any) {
  const isWhitespace = (control.value || '').trim().length === 0;
  const isValid = !isWhitespace;
  return isValid ? null : { whitespace: true };
}

@Directive({
  selector: '[clearOnNo]',
  standalone: false, // Ensure this directive can be used in standalone components
})


export class ClearOnNoDirective implements OnInit {
  @Input('clearOnNo') radioControlName!: string;
  @Input() clearControlName!: string;
  @Input() clearOnYesControlName?: string; // Optional
  @Input() clearOnNoControlName?: string; // Optional

  constructor(
    @Optional() @SkipSelf() private controlContainer: ControlContainer
  ) {}

  

  ngOnInit() {
    const formGroup = this.controlContainer?.control as FormGroup;
    if (!formGroup) return;

    const radioControl = formGroup.get(this.radioControlName);
    const clearControl = formGroup.get(this.clearControlName);
    const clearOnYesControl = this.clearOnYesControlName
      ? formGroup.get(this.clearOnYesControlName)
      : null;
       const clearOnNoControlName = this.clearOnNoControlName
      ? formGroup.get(this.clearOnNoControlName)
      : null;


    if (radioControl) {
      radioControl.valueChanges.subscribe(val => {

          clearOnYesControl?.clearValidators();
           clearControl?.clearValidators();
           clearOnNoControlName?.clearValidators();

        if (val === 'no' && clearControl) {
          clearControl.setValue('');
          clearControl.clearValidators();
          clearControl.updateValueAndValidity();
        }

         if (val === 'no' && clearOnYesControl) {
        clearOnYesControl.setValidators([Validators.required, noWhitespaceValidator]);
        clearOnYesControl.markAsTouched();
        clearOnYesControl.updateValueAndValidity();
      }
        if (val === 'yes' && clearOnYesControl) {
           clearControl?.setValidators([Validators.required, noWhitespaceValidator]);
            clearControl?.markAsTouched();
          clearControl?.updateValueAndValidity();
          clearOnYesControl.setValue('');
          clearOnYesControl.clearValidators();
          clearOnYesControl.updateValueAndValidity();
        }
        if (val === 'yes' && clearControl) {
          clearControl.setValidators([Validators.required, noWhitespaceValidator]);
           clearControl?.markAsTouched();
          clearControl.updateValueAndValidity();
        }
        if (val !== 'yes' && clearControl) {
          clearControl.clearValidators();
          clearControl.updateValueAndValidity();
        }

           if(val === 'no' && this.clearOnNoControlName) {
           clearOnNoControlName?.setValidators([Validators.required, noWhitespaceValidator]);
            clearOnNoControlName?.markAsTouched();
          clearOnNoControlName?.updateValueAndValidity();
        }
        if(val !== 'no' && this.clearOnNoControlName) {
          clearOnNoControlName?.setValue('');
          clearOnNoControlName?.clearValidators();
          clearOnNoControlName?.updateValueAndValidity();
        }
      });
    }
  }
}